<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容："  label-for="key">
              <Input search enter-button placeholder="请输入批次号搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="溯源类型：" prop="key" label-for="key">
              <Select v-model="filter.type" placeholder="请选择类型" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">种植溯源</Option>
                <Option :value="2">养牛溯源</Option>
                <Option :value="3">养猪溯源</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="请求时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import { traceabilityLogListApi } from '@/api/processing/traceability/traceabilityLog'

export default {
  name: 'traceabilityLogList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        search: '',
        type: 0,
        ctime: [],
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '批次号',
          minWidth: 220,
          render: (h, params) => {
            let sn = params.row.out_sn
            if (params.row.type === 1){
              sn = params.row.production_sn
            }

            return h('div', sn)
          }
        },
        {
          title: '溯源类型',
          key: 'type_msg',
          minWidth: 180
        },
        {
          title: '请求位置',
          minWidth: 150,
          render: (h, params) => {
            // 拼接 province和city
            let str = ''
            if (params.row.province){
              str += params.row.province
              if (params.row.city){
                str += ', ' + params.row.city
              }
            }else{
              str = '未知'
            }

            return h('div', str)
          }
        },
        {
          title: '请求时间',
          key: 'ctime',
          minWidth: 150
        },
      ]
    }
  },
  created () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      traceabilityLogListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 清空搜索
    searchClear () {
      this.filter.search = ''
      this.filter.page = 1
      this.loadTableData()
    },
    // 下拉选择
    select (status) {
      this.filter.page = 1
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

  }
}
</script>
